exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.alert[data-v-fbfa3198] {\n  margin-bottom: 0;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);\n}\n.loading-bar[data-v-fbfa3198] {\n  height: 0.33rem;\n  opacity: 75%;\n  bottom: 0;\n  left: 0;\n}\n", ""]);

// exports
